import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";

import theme, { devTheme } from "assets/mui";
import "assets/styles/index.css";
import NotificationProvider from "@hooks/useNotifications";
import Router from "./pages/router";

// Hot reload for esbuild
if ((window as any).IS_ESBUILD) {
  new EventSource("/esbuild").addEventListener("change", () => window.location.reload());
}

const root = ReactDOM.createRoot(document.getElementById("root")!);

const muiTheme = window.appConfig?.mode === "dev" ? devTheme : theme;

root.render(
  <React.StrictMode>
    <ThemeProvider theme={muiTheme}>
      <NotificationProvider>
        <Router />
      </NotificationProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
